// extracted by mini-css-extract-plugin
export default {"menuBlock":"iF-z","title":"jF-z","nav":"kF-z","flexCell":"lF-z","facetLink":"mF-z"};